import { Text } from "@chakra-ui/react";
import { Box, Flex } from "@chakra-ui/layout";
import colors from "core/resources/theme/colors";
import { useDropzone } from "react-dropzone";
import OutlineButton from "ui/components/Button/OutlineButton";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import Button from "ui/components/Button";

interface InputFileDropzoneProps {
  value: File[] | undefined;
  onChange: (files: File[] | null | undefined) => any;
  isInvalid?: boolean;
  accept?: string;
  isMultiple?: boolean;
}
function InputFileDropzone({
  value,
  onChange,
  isInvalid,
  accept = "*",
  isMultiple = true,
}: InputFileDropzoneProps) {
  const _onChange = (files: File[] | null | undefined) => {
    if (value && files) {
      onChange(value.concat(files));
    } else {
      onChange(files);
    }
  };
  const { getRootProps, getInputProps, isDragActive, inputRef } = useDropzone({
    onDrop: _onChange,
    noKeyboard: true,
    noClick: true,
    maxFiles: isMultiple ? undefined : 1,
  });

  const onClick = () => {
    inputRef.current && inputRef.current.click();
  };

  return (
    <Flex
      mt={2}
      rounded={4}
      w="100%"
      minH="200px"
      maxH="350px"
      borderStyle="dashed"
      borderColor={isInvalid ? "red" : colors.black50}
      borderWidth={3}
      flexDir="column"
      alignItems={value?.length ? "flex-start" : "center"}
      justifyContent={value?.length ? "flex-start" : "center"}
      bg={colors.white}
      {...getRootProps()}
    >
      {value?.length && isMultiple ? (
        <Flex w="100%" px="12px" justifyContent="flex-end">
          <PrimaryButton onClick={onClick} mt={2}>
            Adicionar outro
          </PrimaryButton>
        </Flex>
      ) : null}

      <Box as="span" display="none">
        <input
          ref={inputRef}
          type="file"
          {...getInputProps()}
          accept={accept}
          multiple={isMultiple}
          onChange={(ev) => {
            _onChange(ev.target.files ? Array.from(ev.target.files) : null);
          }}
        />
      </Box>

      {value?.length ? (
        <Box
          w="calc(100% - 32px)"
          mx="16px"
          mt="16px"
          borderTop="1px solid #efefef"
          position="relative"
          overflowY="auto"
          py={2}
        >
          <Flex w="100%" flexDir="column">
            {value.map((file, i) => (
              <Flex key={i} alignItems="center" mb={2}>
                <Flex flex={1}>
                  <Text fontSize={15}>{file.name}</Text>
                </Flex>
                <Flex>
                  <Button
                    h={"30px"}
                    variant="outline"
                    size="small"
                    colorScheme="red"
                    onClick={() => {
                      onChange(value.filter((_v, _i) => _i !== i));
                    }}
                  >
                    Remover
                  </Button>
                </Flex>
              </Flex>
            ))}
          </Flex>
        </Box>
      ) : isDragActive ? (
        <Text>Solte {isMultiple ? "os arquivos" : "o arquivo"}</Text>
      ) : (
        <>
          <OutlineButton onClick={onClick}>
            Escolher {isMultiple ? "arquivos" : "arquivo"}
          </OutlineButton>

          <Text mt={2}>
            Ou solte {isMultiple ? "os arquivos" : "o arquivo"} aqui
          </Text>
        </>
      )}
    </Flex>
  );
}

export default InputFileDropzone;
